import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineAbilityConfig} from '../system/defineAbilityConfig';

// This controls access to site branching (Releases) features.
export const canAccessSiteBranching = defineAbilityConfig({
  featureFlags: {
    [FEATURE_FLAGS.SITE_BRANCHES]: true,
  },
  abilities: {canAccessPageBranching: true},
} as const);

export const canStageSiteBranch = defineAbilityConfig({
  featureFlags: {
    [FEATURE_FLAGS.SITE_BRANCHES]: true,
  },
  userTypes: {
    authorizedInDesigner: true,
  },
  pageScope: ['siteBranch'],
  permission: ['publish', 'siteBranch'],
} as const);
